<mat-dialog-content>
  <div class="dialog" fxLayout="column" fxLayoutAlign="center center">
    <!-- close x -->
    <i (click)="close()" class="closex fas fa-times"></i>

    <div class="dialog-content" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
      <div style="word-wrap: break-word; text-align: center">
        <h2>Willkommen beim Zimmerer-Treffpunkt!</h2>
        Schön, dass Du dabei bist.<br />
        Was willst Du als erstes tun?
      </div>

      <div class="tileGrid">
        <div
          class="tile"
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutGap="10px"
          (click)="goto('/profile/about')"
        >
          <img [src]="environment.publicFolder + 'assets/images/fortgeschrittener.png'" />
          <div>Mein Profil vervollständigen</div>
        </div>
        <div class="tile" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" (click)="goto('/news')">
          <i class="fas fa-newspaper"></i>
          <div>News ansehen</div>
        </div>

        <div class="tile" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" (click)="goto('/market')">
          <i class="fas fa-shopping-cart"></i>
          <div>Im Marktplatz einkaufen oder verkaufen</div>
        </div>
        <div class="tile" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" (click)="goto('/job')">
          <i class="fas fa-building"></i>
          <div>Einen Job oder Mitarbeiter finden</div>
        </div>

        <div
          class="tile"
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutGap="10px"
          (click)="goto('/blog?blog_category_id=' + CategoriesService.videocat.id)"
        >
          <i class="fas fa-video"></i>
          <div>Videos ansehen</div>
        </div>
        <div
          class="tile"
          fxLayout="column"
          fxLayoutAlign="center center"
          fxLayoutGap="10px"
          (click)="goto('/grundwissen')"
        >
          <i class="fas fa-university"></i>
          <div>Mich weiterbilden</div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
